import React, { useEffect, useState } from 'react'
import AlertEvidenceList from '../Alerts/AlertEvidenceList'
import { Modal, ModalBody, OverlayTrigger, Tooltip } from 'react-bootstrap'
import { AttachEvidenceIcon, evidence, RemoveIcon} from '../../assets/images'
import { getAlertEvidenceList } from '../../services/alertAuthService'

const EvidenceList = ({alertId}) => {
   const [display, setDisplay] = useState(false)
    const [tempevidencelist, settempevidencelist] = useState([])

     useEffect(() => {
            getEvidenceList();
        }, [])

        const openModal = (e) => {
            e.stopPropagation();
            setDisplay(true);
        }
        const closeModal = (e) => {
            setDisplay(false)
        }
        const downloadFile = async (title,url) => {
            try {
                if(title.includes(".mp4") || title.includes(".pdf") || title.includes(".txt") || title.includes(".png") || title.includes(".jpg") || title.includes(".mp3") || title.includes(".xlsx")){
                    const response = await fetch(url);
                    const blob = await response.blob();
                    const local_url = window.URL.createObjectURL(blob);
        
                    const a = document.createElement('a')
                    a.href = local_url;
                    a.download = title
                    document.body.appendChild(a);
                    a.click()
                    a.remove()
                    window.URL.revokeObjectURL(url);
        
                }else{
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = title
                    document.body.appendChild(a);
                    a.click()
                    document.body.removeClild();
                }
            } catch (error) {
                console.log(error);
            }
        }

     const getEvidenceList = () => {
            let loggedInUser = JSON.parse(localStorage.getItem('user'))
            getAlertEvidenceList(loggedInUser?.Id,alertId)
                .then((res) => {
                    if(res.Status == 'success'){
                        settempevidencelist(res.Data)
                        
                    }
                }).catch(err => console.log(err))
        }
  return (
   <>
<div>
        <OverlayTrigger
                    placement="auto"
                    overlay={<Tooltip id="tooltip-bottom" style={{ zIndex: 99999 }}>Attached Evidences</Tooltip>}                
                >
                    <button
                    className="TwoWayAudioToggle two-way-and-hooter-on-off blink"
                    onClick={(e) => openModal(e)}
                    // style={{ position: 'relative', zIndex: 100000 }}
                    >
                        <img
                          style={{ padding: "2px", color: 'white' }}
                            src={AttachEvidenceIcon}
                          alt="location icon"
                        />
                    </button>
        </OverlayTrigger>
</div>
<div onClick={(e) => e.stopPropagation()}>
                <Modal 
                show={display}
                size='xl' id="tooltip-bottom" style={{ zIndex: 99999 }} dialogClassName="healthMonitorModel AttachEvedenceModal" onHide={(e) => closeModal(e)}
               
               >

                <Modal.Header >
                    <Modal.Title id="example-custom-modal-styling-title">
                        Attached Evidences
                    </Modal.Title>
                    <img
                        src={RemoveIcon}
                        alt="Remove"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                            closeModal(false)
                        }}
                    />
                </Modal.Header>
                <Modal.Body>
                <div>
                            <p className="UploadText">Attached Evidences</p>
                            <span className="GreenText">{tempevidencelist.length} attachments</span>
                            <div className="AttachmentsDiv">
                                <div className="mainContentList" style={{paddingTop: '0.1rem', height: '18rem'}}>
                                    {
                                        tempevidencelist &&
                                        tempevidencelist.length > 0 &&
                                        (tempevidencelist.map((item) => (
                                <AlertEvidenceList item={item} key={item.IncReportDocsID} downloadFile={downloadFile} />
                                        )))
                                    }
                                </div>
                            </div>
                        </div>
   
                </Modal.Body>
                    
                </Modal>
        </div>
   </>
    
        
               
               
    
             
  )
}

export default EvidenceList

